import { render, staticRenderFns } from "./GeneralRightsEditor.vue?vue&type=template&id=3b1cbd42&scoped=true"
import script from "./GeneralRightsEditor.vue?vue&type=script&lang=js"
export * from "./GeneralRightsEditor.vue?vue&type=script&lang=js"
import style0 from "./GeneralRightsEditor.vue?vue&type=style&index=0&id=3b1cbd42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1cbd42",
  null
  
)

export default component.exports